// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueConfig from 'vue-config';
import axios from 'axios';
import VueMasonry from 'vue-masonry-css';
import App from './App';
import router from './router';
import './styles/app.scss';

async function startServer() {
  let confData = null;
  try {
    confData = await axios.get('/static/config/services.json');
  } catch (e) {
    // eslint-disable-next-line
    console.warn('cannot get config: ', e.message);
  }

  const configs = {
    API: confData.data.API,
  };

  Vue.config.productionTip = false;
  Vue.use(VueResource);
  Vue.use(VueConfig, configs);
  Vue.use(VueMasonry);

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
      App,
    },
  });
}

try {
  startServer();
} catch (e) {
  // eslint-disable-next-line
  console.warn('Error while starting app: ', e.message);
}


async function check() {
  try {
    await axios.get('http://localhost:4242/');
  } catch (e) {
    // eslint-disable-next-line
    console.log(`Watchdog Error: ${e.message}`);
  }
}

check();
setInterval(check, 60 * 1000);



// WEBPACK FOOTER //
// ./src/main.js